import { Contact } from '@dreamstack/payload/src/payload-types'
import type { FunctionComponent } from 'react'
import { HeadingH3 } from './Texts'

export const NewsArticleContact: FunctionComponent<
  React.PropsWithChildren<{
    contact: Contact
  }>
> = ({ contact }) => {
  const { title, fullName, company, email, postcode, telefon, street } = contact

  return (
    <div className="mb-px-64">
      <HeadingH3>{title}</HeadingH3>
      <div className="mt-px-24">
        <p>{fullName}</p>
        <p>{company}</p>
        <p>{street}</p>
        <p>{postcode}</p>
      </div>
      <div className="flex space-x-px-24 mt-px-24">
        <div>
          <p>E-Mail</p>
          <p>Telefon</p>
        </div>
        <div>
          <p>{email}</p>
          <p>{telefon}</p>
        </div>
      </div>
    </div>
  )
}
